export enum PhoneNumberEditStep {
  PHONE_NUMBER = 'phoneNumber',
  PHONE_NUMBER_USED_WITH_COUPON = 'phoneNumberUsedWithCoupon',
  VERIFICATION_CODE = 'verificationCode',
}
